import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { LOGOUT_MAINTAIN, isTokenPresent } from '../config/helper';
import { useDispatch } from 'react-redux';

const CheckComponent = () => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  useEffect(() => {
    if (!Number.isNaN(Number(localStorage.getItem("expiresAt"))) && Number(localStorage.getItem("expiresAt")) < new Date().getTime()) {
      localStorage.clear()
      dispatch({
        type: LOGOUT_MAINTAIN,
        payload: true,
      })
    } else if (isTokenPresent()) {
      if (localStorage.getItem("is_super_admin")) {
        const permissions = localStorage.getItem("permissions")
        const path = `/admin/${permissions ? permissions?.split(",")?.[0] : "customers"}`;
        history.push(path)
      } else {
        history.push("/dashboard")
      }
    } else {
      if (location.pathname.includes("admin")) {
        history.push("/admin/")
      } else {
        history.push("/")
      }
    }
    // eslint-disable-next-line
  }, [])

  return null;
};

export default CheckComponent;